
/**
 * Used in an EventEmitter to pass on Barcode information to the parent element
 *
 * @author hillebrand
 */
export class BarCode {
  shipToCode: string;
  shipmentDate: Date;
  shoppingCartNo: string;
  description: string;
  barcode: string;
  salesPrice: string;
  originalPrice: string;

  constructor(obj?: any) {
    this.shipToCode = (obj && obj.shipToCode) || null;
    this.shipmentDate = (obj && obj.shipmentDate) || null;
    this.shoppingCartNo = (obj && obj.shoppingCartNo) || null;
    this.description = (obj && obj.description) || null;
    this.barcode = (obj && obj.barcode) || null;
    this.salesPrice = (obj && obj.salesPrice) || null;
    this.originalPrice = (obj && obj.originalPrice) || null;
  }
}
